/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum BasicStatus {
    NotSet = 0,
    Done = 1,
    Incomplete = 2,
    Delayed = 3,
    Active = 4,
    Paused = 5,
}
